import React from 'react';
import { Link } from 'react-router-dom';
import './Avatar.scss';

class Avatar extends React.Component {
  render() {
    return (
      <Link to={this.props.url || '/'} className="avatar-block">
        {this.props.src ? (
          <img
            src={this.props.src}
            width={this.props.width}
            height={this.props.height}
            alt={this.props.name}
          />
        ) : (
          <i>{this.props.firstLetters}</i>
        )}
        <div className="user-info">
          <label>{this.props.name}</label>
          <span>{this.props.text}</span>
        </div>
      </Link>
    );
  }
}

export default Avatar;
